// eslint-disable-next-line
export const validateForm = {
  created() {
    this.$validator.extend('complexity', {
      getMessage: () => this.$t('LNG_PASSWORD_DOES_NOT_MATCH_REQUIREMENTS'),
      validate: (value, args) => this.$getPasswordComplexity(value).complexity > args[0],
    });
    this.$validator.extend('sc_image', {
      getMessage: () => this.$t('LNG_FILE_IS_NOT_IMG'),
      validate: (file) => {
        const mimes = ['image/jpeg', 'image/png'];
        const regex = new RegExp(`${mimes.join('|').replace('*', '.+')}$`, 'i');
        return regex.test(file.type);
      },
    });
    this.$validator.extend('kendoDTP', {
      getMessage: (field, params, data) =>
        (data && data.message) || this.$t('LNG_APPOINTMENT_DATE_ERROR'),
      // eslint-disable-next-line
      validate: (value, args) => {
        return new Promise((resolve) => {
          let valid = value !== '';
          let message = 'LNG_EMPTY_VALUE';
          if (args.format) {
            valid &= this.$moment(value, args.format).isValid(); // eslint-disable-line no-bitwise
            message = 'LNG_INVALID_FORMAT';
          }
          if (args.min) {
            const min = this.$moment(args.min, args.format);
            const dt = this.$moment(value, args.format);
            if (args.allDay) {
              valid &= dt.isSameOrAfter(min, 'day'); // eslint-disable-line no-bitwise
            } else {
              valid &= dt.isSameOrAfter(min); // eslint-disable-line no-bitwise
            }

            message = 'LNG_DATE_MUST_BE_GREATER_THAN';
          }

          resolve({
            valid,
            data: { message },
          });
        });
      },
    });
    this.$validator.extend('kendoBD', {
      getMessage: (field, params, data) => (data && data.message) || this.$t('LNG_DATE_ERROR'),
      // eslint-disable-next-line
      validate: (value, args) => {
        return new Promise((resolve) => {
          let valid = value !== '';
          let message = 'LNG_EMPTY_VALUE';
          if (args.format) {
            valid &= this.$moment(value, args.format).isValid(); // eslint-disable-line no-bitwise
            message = 'LNG_INVALID_FORMAT';
          }

          const min = this.$moment().subtract(100, 'years');
          const max = this.$moment();
          const dt = this.$moment(value, args.format);
          valid &= dt.isBetween(min, max); // eslint-disable-line no-bitwise
          message = 'LNG_DATE_MUST_BE_BETWEEN_100_TODAY';
          resolve({
            valid,
            data: { message },
          });
        });
      },
    });
    this.$validator.extend('kendoDate', {
      getMessage: (field, params, data) => (data && data.message) || this.$t('LNG_DATE_ERROR'),
      // eslint-disable-next-line
      validate: (value, args) => {
        return new Promise((resolve) => {
          let valid = value !== '' || value === '';
          let message = 'LNG_EMPTY_VALUE';
          if (args.format) {
            valid &= this.$moment(value, args.format).isValid(); // eslint-disable-line no-bitwise
            message = 'LNG_INVALID_FORMAT';
          }

          const min = this.$moment().subtract(100, 'years');
          const max = this.$moment().add(100, 'years');
          const dt = this.$moment(value, args.format);
          valid &= dt.isBetween(min, max); // eslint-disable-line no-bitwise
          message = 'LNG_DATE_MUST_BE_BETWEEN_100_TODAY';
          if (valid) message = '';
          resolve({
            valid,
            data: { message },
          });
        });
      },
    });
    this.$validator.extend('infrastructureAvailable', {
      getMessage: (field, params, data) => (data && data.message) || this.$t('LNG_DATE_ERROR'),
      validate: (value, args) => {
        const availability = [];
        if (args.infrastructures) {
          args.infrastructures.forEach((infra) => {
            if (value.includes(infra.id)) {
              availability.push(infra.available || args.appointment === infra.usedBy[0]);
            }
          });
        }

        return !availability.includes(false);
      },
    });
  },
  mounted() {
    this.$initCommonPasswordFile();
  },
  methods: {
    validateState(ref, scope) {
      if (scope) {
        if (
          this.veeFields[`$${scope}`] &&
          this.veeFields[`$${scope}`][ref] &&
          (this.veeFields[`$${scope}`][ref].dirty || this.veeFields[`$${scope}`][ref].validated)
        ) {
          return !this.errors.has(`${scope}.${ref}`);
        }
      } else if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
  },
};
